/* script */
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import OnsiteScanningSettings from 'ui/components/printing/OnsiteScanningSettings.vue';
import PrinterSettings from 'ui/components/printing/PrinterSettings.vue';
import KioskSettings from 'ui/components/printing/KioskSettings.vue';

// Constants
const KEY_TO_COMP_MAP = {
    'onsite_scanning_client': OnsiteScanningSettings,
    'kiosk': KioskSettings,
    'badge_printing': PrinterSettings
};

const __vue_script__ = {
    name: 'BadgePrintingSettings',

    components: {
        OnsiteScanningSettings,
        PrinterSettings,
        KioskSettings
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const scope = get(this.params, 'currentController.routeOptions.settingsKey');
        const currentComponent = KEY_TO_COMP_MAP[scope];

        return {
            event: this.params.event,
            config: {},
            registry: {},
            currentComponent,
            scope,
            ready: false
        };
    },

    created() {
        this.init();
    },

    methods: {
        async init(skipCache) {
            try {
                this.config = await this.$services.settings.getSetting(this.params.event._id, this.scope, skipCache ? 0 : 5000);
                this.registry = await this.$services.settings.getRegistrySettings(this.params.event._id, this.scope, skipCache ? 0 : 5000);

                console.info('[BadgePrintingSettings] Settings loaded', this.config);
                this.ready = true;
            } catch (error) {
                console.error('[BadgePrintingSettings] Could not load settings', error);
            }
        },

        async save(data) {
            try {
                console.info('[BadgePrintingSettings] Saving branding settings (%s):', this.scope, data);
                const eventId = this.params.event._id;
                await this.$services.settings.saveSetting(eventId, this.scope, data);
                this.$emit('saved');

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('onsite_scanning.settings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.init(true);

            } catch (error) {
                console.error('[BadgePrintingSettings] Could not save settings', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('onsite_scanning.settings.messages.save_failure').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        },

        async showErrorMessage() {
            this.$notify({
                group: 'flashes',
                title: this.$i18n.t('general.error_occurred').toString(),
                text: this.$i18n.t('onsite_scanning.settings.messages.save_failure_required_fields').toString(),
                type: 'error',
                duration: 5000
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "badge-printing-settings" },
    [
      _vm.ready
        ? _c(_vm.currentComponent, {
            tag: "component",
            attrs: {
              event: _vm.event,
              config: _vm.config,
              registry: _vm.registry,
            },
            on: { valid: _vm.save, invalid: _vm.showErrorMessage },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/printing/BadgePrintingSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__